<template>
    <div class="welcome-section">

      <div class="badges"><br>
          <p>
              <span class="firstLine">Nu även</span><br>
              <span class="secondLine">möjlighet till</span><br>
              <span class="thirdLine">psykologisk</span><br>
              <span class="fourthLine">behandling!</span>
          </p>
      </div>

      <h1 class="welcome">Hjälp mot potensproblem.</h1>
      <h4 class="welcome">Ansök om recept via vårt formulär, utan telefon eller videochatt.</h4>
      <div class="start-button primary-btn"><router-link to="/recept"><h5>Till formuläret</h5></router-link></div>
      <div class="blurb-container">
        <transition name="fade" mode="out-in">
          <div class="blurb one" v-if="showBlurbOne">"Jag tackar så mycket för det smidiga förfarandet och hjälpen jag fått. Jag är helnöjd och mitt och min frus samliv har fått en rejäl kvalitetshöjning"<span class="blurb-name">Kjell, 61 år</span></div>
        </transition>
        <transition name="fade" mode="out-in">
          <div class="blurb two" v-if="showBlurbTwo">"Jag är utomordentligt nöjd med upplevelsen av er tjänst. Det var mycket enkelt att fylla i formuläret samt en snabb hantering från er sida. Jag kommer att använda er nästa gång igen. Tack!"<span class="blurb-name">Per-Erik, 60 år</span></div>
        </transition>
        <transition name="fade" mode="out-in">
          <div class="blurb three" v-if="showBlurbThree">"Denna tjänsten är helt enkelt superbra. Precis som ni skriver så är det inte så bekvämt att gå till en läkare med dessa problem. Jag vet att mina kommer från prestationsångest, då min fru och jag försökt att få ett barn till och försöker tima hennes ägglossning. Inte alltid så roligt. Tusen tack!"<span class="blurb-name">Christian, 49 år</span></div>
        </transition>
      </div>
    </div>
</template>
<script>
import axios from "axios"

export default {
    name: "Welcome", 
    data() {
      return {
        showBlurbOne: true,
        showBlurbTwo: false,
        showBlurbThree: false
      }
    },
    mounted() {

      this.rotateBlurbs();

      this.$store.commit( 'persist/setShowConfirmation', { showConfirmation: false })
      this.$store.commit( 'persist/setConfirmationType', { confirmationType: '' })
      this.$store.commit( 'persist/setIdentificationNumber', { identificationNumber: '' } )
      this.$store.commit( 'persist/setName', { givenName: '', familyName: '' } )
      this.$store.commit( 'persist/setFamilyName', { familyName: '' } )
      this.$store.commit( 'persist/setProduct', { product: '' })
      this.$store.commit( 'persist/setVerificationData', { cert: '', signature: '', ocspResponse: '' } )
      this.$store.commit( 'persist/setFinalFormData', { finalFormData: '' })
      this.$store.commit( 'persist/setEmail', { email: '' })
      this.$store.commit( 'persist/setPhone', { phone: '' })
      this.$store.commit( 'persist/setPreferredContact', { preferredContact: '' })

      // wake up dyno1
      axios({
        method: "get",
        url: process.env.VUE_APP_API_BASE_URL + "wake",
        params: {
            version: "141",
        }
      })
        .then(response => {
            // eslint-disable-next-line
            console.log(response.data)
          })
          /* eslint-disable no-unused-vars */
          .catch(response => {
            this.response = response
        })


    },
    methods: {
      rotateBlurbs() {

        const showSecond = setTimeout(() => {
          this.showBlurbOne = false;
          setTimeout(() => {
            this.showBlurbTwo = true;
          }, 1500)
          this.showBlurbThree = false;
          this.clearBlurbTimeout(showSecond);
        }, 8000);

        const showThird = setTimeout(() => {
          this.showBlurbOne = false;
          this.showBlurbTwo = false;
          setTimeout(() => {
            this.showBlurbThree = true;
          }, 1500)
          this.clearBlurbTimeout(showSecond);
        }, 17000);

        const showFirst = setTimeout(() => {
          setTimeout(() => {
            this.showBlurbOne = true;
          }, 1500)
          this.showBlurbTwo = false;
          this.showBlurbThree = false;
          this.clearBlurbTimeout(showSecond);
          this.rotateBlurbs();
        }, 30000);

      },
      clearBlurbTimeout(loop) {
        clearTimeout(loop);
      }
    }
}
</script>
